import { Component } from '@angular/core';
import { Constants } from 'avn/modules/services/constants';
import moment from 'moment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.html',
  styleUrls: ['./footer.scss']
})
export class FooterComponent {
  public currentYear = moment().format('YYYY');
  public branding = Constants.BRANDING;
}
